module.exports = __webpack_public_path__ + "media/images/manage_roles_active-8b2cf43601657521b65a649dfe62a21a.png";